import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';
import { useContext } from './Context';
import InvitePopup from './Invite/Popup';

export default function Table() {
  const { dispatch, actions, state } = useContext();
  const [keyword, setKeyword] = useState('');
  const [selectedAffiliate, setSelectedAffiliate] = useState(null);

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  const inviteAffiliate = (affiliate) => {
    setSelectedAffiliate(affiliate);
  };

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(inviteAffiliate)}
          data={data(state.affiliates, keyword) || []}
          noDataComponent={(
            <div className="mt20">
              {state.affiliates == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
      {selectedAffiliate && (
      <InvitePopup
        affiliate={selectedAffiliate}
        closePopup={() => {
          setSelectedAffiliate(null);
        }}
      />
      )}
    </>
  );
}
